import { useCallback } from 'react';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useDispatch, useSelector } from 'react-redux';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import { getLabelMessage, getMessage } from '@gef-ui/localization/messages';

import SortCell from 'components/atoms/GefMui/SortCell';
import acl from 'features/common/acl';
import fetch from 'features/common/fetch';
import userContext from 'features/views/userContext';
import usersSubordinate from 'features/views/usersSubordinate';

const { KCL_DISPLAY_SUBORD_POLICY_LIST } = acl.constants;

export const SubordinateUsersTableHead = () => {
	const dispatch = useDispatch();

	const contextUser = useSelector(userContext.selectors.getContextUser);

	const fetchStorePath = `${fetch.constants.urls.userList}.${contextUser ? contextUser.login : 'root'}`;

	const { queryParams = {} } = useSelector(fetch.selectors.getLastRequest(fetchStorePath));

	const metaData = useSelector(fetch.selectors.getMetaData(fetchStorePath));

	const sort = queryParams.sort || ['surname,asc', 'firstName,asc'];
	const xPadding = 1;

	const handleSort = useCallback(
		(sort) => {
			dispatch(usersSubordinate.actions.fetchSubordinateUsers(metaData.page, sort));
		},
		[dispatch, metaData],
	);

	const hasRecords = Boolean(metaData.totalRows);

	return (
		<TableHead>
			<TableRow>
				<TableCell sx={{ px: xPadding }}>{getLabelMessage('subordinateUsers:sellerIn')}</TableCell>
				<TableCell>
					<SortCell hasRecords={hasRecords} sortBy={['surname', 'firstName']} sort={sort} onSort={handleSort}>
						{getLabelMessage('subordinateUsers:tableClientName')}
					</SortCell>
				</TableCell>
				<TableCell sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center', px: xPadding }}>
					<SortCell hasRecords={hasRecords} sortBy={'taskCountActNoInfo'} sort={sort} onSort={handleSort}>
						<div>{getLabelMessage('subordinateUsers:tableTasksFirst')}</div>
						<div>{getMessage('subordinateUsers:tableTasksSecond')}</div>
					</SortCell>
				</TableCell>
				<TableCell sx={{ textAlign: 'center', px: xPadding }}>
					{getLabelMessage('subordinateUsers:tableTasksInformations')}
				</TableCell>
				<TableCell sx={{ textAlign: 'center', px: xPadding }}>
					{getLabelMessage('subordinateUsers:tableMarketPlaceLeads')}
				</TableCell>
				<TableCell sx={{ textAlign: 'center', px: xPadding }}>
					{getLabelMessage('subordinateUsers:tableSemafor')}
				</TableCell>
				<TableCell sx={{ textAlign: 'center', px: xPadding }}>
					{getLabelMessage('subordinateUsers:tableRaAnalysis')}
				</TableCell>
				<TableCell sx={{ textAlign: 'center', px: xPadding }}>
					<AccessControl accessLevel={KCL_DISPLAY_SUBORD_POLICY_LIST}>
						{getLabelMessage('subordinateUsers:tablePS')}
					</AccessControl>
				</TableCell>
				<TableCell sx={{ textAlign: 'center', px: xPadding }}>
					{getLabelMessage('subordinateUsers:tableSubordinates')}
				</TableCell>
				<TableCell sx={{ textAlign: 'center', px: xPadding }}>
					{getLabelMessage('subordinateUsers:tableKH')}
				</TableCell>
				<TableCell sx={{ textAlign: 'center', px: xPadding }}>
					{getLabelMessage('subordinateUsers:tableUnlockedClients')}
				</TableCell>
				<TableCell sx={{ textAlign: 'center', paddingLeft: xPadding, paddingRight: 1.5 }}>
					{getLabelMessage('subordinateUsers:tableSettings')}
				</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default SubordinateUsersTableHead;
